import { connect } from 'react-redux';
import { currentClassRoomId } from '../../../../../../core/selectors/classroom';
import { goToAssignments } from '../../../../../actions/navigation';
import goToFeed from '../../../../../actions/navigation/goToFeed';
import PostNavigation from './PostNavigation';

const mapStateToProps = (state) => ({
  spaceId: currentClassRoomId(state),
});

const mapDispatchToProps = (dispatch) => ({
  goToFeed: (spaceId) => () => dispatch(goToFeed(spaceId)),
  goToAssignments: (spaceId) => () => dispatch(goToAssignments(spaceId)),
});

const mergeProps = (stateProps, dispatchProps, ownProps) => ({
  ...stateProps,
  ...dispatchProps,
  ...ownProps,
  goToFeed: dispatchProps.goToFeed(stateProps.spaceId),
  goToAssignments: dispatchProps.goToAssignments(stateProps.spaceId),
});

const PostNavigationContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(PostNavigation);

export default PostNavigationContainer;
